import { Injectable, Inject } from 'ng-metadata/core';
import {Cheetah} from '../../../search/cheetah.service';
import {getVid} from '../../../appConfig/appConfigForward';
import {SearchFieldsService} from '../../search.fields.service';
import {getBackendSystem} from '../../../appConfig/appConfigForward';
import {StorageUtil} from "../../../infra/storageUtil.service";
import {NewspapersService} from "../../../newspapers/newspapers.service";


@Injectable()


export class AddQueryToSavedSearchesService {
   private GET_URL:string;
    
   constructor (private cheetahService:Cheetah,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$httpParamSerializer') private $httpParamSerializer: ng.IHttpParamSerializer,
                private searchFieldsService: SearchFieldsService,
                private storageUtil: StorageUtil,
                private newspapersService: NewspapersService) {
            this.GET_URL= restBaseURLs.saveSearchURL;
  }
    
    
    calculatePayload(){
        
        let queryUrl = '';
        if (getBackendSystem() === 'suprima') {
            queryUrl= this.$location.protocol() + '://' +  location.host + '/discovery/search?' + this.$httpParamSerializer(this.searchFieldsService.searchParams);
        } else {
            queryUrl= this.$location.protocol() + '://' +  location.host + '/primo-explore/search?' + this.$httpParamSerializer(this.searchFieldsService.searchParams);
            if (this.newspapersService.isNewspapersSearch()) {
                queryUrl = this.$location.absUrl();
            }
        }
        queryUrl = this.multiReplace(queryUrl, '+','%20');

        let payload = {'add':[{'searchData':this.cheetahService.searchData,'queryUrl':queryUrl, 'suprimaSearchApiurl':this.storageUtil.sessionStorage.getItem('suprimaSearchApiurl')}] };
        return payload;

    }

       multiReplace(str, match, repl) {
            if (match === repl)
                return str;
            do {
                str = str.replace(match, repl);
            } while(str.indexOf(match) !== -1);
            return str;
        }
    
    
    addItems(){
       let payload = this.calculatePayload();
       
       return this.makeRequest('add', payload,'POST', '/add?vid=' + getVid());
    }
    
    public makeRequest(serviceName: string, params: Object = null, method: string = null, suffixPath:string = '') {
        
        let httpConfig = {
            method: method,
            url: this.GET_URL + suffixPath,
            params: method === 'GET' ? params : null,
            data: method === 'POST' || method==='PUT'? params : null
        };

        return this.$http(httpConfig)
            .then(
                (response)=> this.reqSuccess(response.data),
                (error)=>this.reqFailure(error, serviceName, params)
            );
    }
    
    private reqSuccess(response){
        
        return response;
    }

    private reqFailure(reason, serviceName, params){
        
        throw reason;
    }
    
    //Following code fixes a bug with mdToast who places "position: relative" on root element but doesn't remove it once it is closed. 
    //This causes md-dialog to not display correctly.
    public onToastClose(){ 
    
        angular.element(document.querySelector("primo-explore")).css('position', '');
    }
    
    
    
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service.ts